module.exports = __webpack_public_path__ + "img/tx-_0000s_0002_3.c5f0684c.png";